import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox, IconButton, InputText } from '@dixa/lib-shared-habla';
import { forwardRef, memo, useCallback, useImperativeHandle, useLayoutEffect, useRef, } from 'react';
import { useUpdateEffect } from 'react-use';
const AnalyticsFilterSearch = ({ value, isOpen, isDisabled, onChange }, forwardedRef) => {
    const inputRef = useRef(null);
    useImperativeHandle(forwardedRef, () => inputRef.current);
    useLayoutEffect(() => {
        if (isOpen) {
            // This has to be done in the next event loop frame through a timeout as
            // the DOM elements would otherwise not be ready.
            setTimeout(() => {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
    }, [isOpen, onChange]);
    useUpdateEffect(() => {
        if (!isOpen) {
            onChange('');
        }
    }, [isOpen]);
    const handleSearch = useCallback((event) => {
        onChange(event.target.value);
    }, [onChange]);
    const handleClearSearch = () => {
        var _a;
        onChange('');
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return (_jsx(InputText, { ref: inputRef, value: value, onChange: handleSearch, placeholder: "Search...", disabled: isDisabled, suffix: {
            type: 'custom',
            value: (_jsx(FlexBox, Object.assign({ alignItems: "center", padding: "0 100" }, { children: _jsx(IconButton, { variant: "tertiary", icon: value ? 'close' : 'search', onClick: value ? handleClearSearch : undefined }) }))),
            noWrap: true,
        } }));
};
export const AnalyticsFilterSearchMemo = memo(forwardRef(AnalyticsFilterSearch));
export { AnalyticsFilterSearchMemo as AnalyticsFilterSearch };
